/**
 * Per-lever [min, max] bounds for the config levers — the ONE source of truth, shared by the Settings UI
 * (clamp on blur) and the /api/config route (reject out of range). Before this was enforced they lived only
 * client-side and cosmetically: a direct API call could store floor = 5 (a 500% floor → price = COGS/(1−5),
 * i.e. NEGATIVE) or priceJumpConfirmPct = 0 (disabling the fat-finger guard). Margin floors cap below 1
 * (price = COGS/(1−floor) must never divide by ≤ 0); inflation/threshold fractions get headroom (> 1 is
 * legitimate in high inflation); day/count fields get sane integer ranges. A rial-amount lever with no
 * natural ceiling (e.g. gaMonthly) is absent here and the route caps it at MAX_RIAL instead.
 */
export const CONFIG_BOUNDS = {
    floor: [0, 0.99],
    target: [0, 0.99],
    redFloor: [0, 0.99],
    amberFloor: [0, 0.99],
    confFloor: [0, 1],
    freightPct: [0, 1],
    vatRate: [0, 1],
    carryRate: [0, 1],
    overdueCollect: [0, 1],
    scrapPct: [0, 1],
    priceProofMinShare: [0, 1],
    matInfl: [0, 5],
    termsDriftWarnPct: [0, 5],
    indexOutlierPct: [0, 5],
    indexSaneMaxPct: [0, 5],
    // A positive floor so the 10× fat-finger / Toman-Rial guard can never be silently disabled by pct = 0.
    priceJumpConfirmPct: [0.01, 20],
    defaultAdvancePct: [0, 100],
    stale: [0, 3650],
    defaultNetDays: [0, 3650],
    supplierNetDays: [0, 3650],
    supplierLeadDays: [0, 3650],
    piValidityMaxDays: [0, 3650],
    termsDriftWindowDays: [1, 3650],
    termsDriftDedupeDays: [0, 3650],
    absorptionTrailingMonths: [1, 60],
    priceProofDays: [0, 3650],
    driftMinSignalQty: [0, 1_000_000],
};
//# sourceMappingURL=configBounds.js.map